var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 49,
    viewBox: "0 0 89 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7272 0.155029L39.921 0.155029L15.611 24.465L39.921 48.775H24.7272L0.417236 24.465L24.7272 0.155029ZM49.0372 0.155119L64.231 0.155119L39.921 24.4651L64.231 48.7751L49.0372 48.7751L24.7272 24.4651L49.0372 0.155119ZM88.5409 0.155119L73.3472 0.155119L49.0372 24.4651L73.3472 48.7751H88.5409L64.231 24.4651L88.5409 0.155119Z",
    fill: "url(#paint0_linear_1_2541)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2541",
    x1: 0.417236,
    y1: 24.465,
    x2: 73.3472,
    y2: 24.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD053",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow);
export default __webpack_public_path__ + "static/media/leftarrow.065e05f1fb04865b7303c1a7dfb26c95.svg";
export { ForwardRef as ReactComponent };